module.exports = __webpack_public_path__ + "static/img/certificateCG.a769c3d8.jpg";